interface LockIconSize24Props {
  className?: string;
}

const defaultProps = {
  className: undefined,
};

function LockIconSize24({ className }: LockIconSize24Props) {
  return (
    <svg
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M17 10.5H7C5.9 10.5 5 11.4 5 12.5V19.5C5 20.6 5.9 21.5 7 21.5H17C18.1 21.5 19 20.6 19 19.5V12.5C19 11.4 18.1 10.5 17 10.5Z"
          fill="#FFB600"
        />
        <path
          d="M16.2 7.09995C16.2 4.69995 14.1 2.89995 11.6 3.29995C9.7 3.59995 8.5 5.39995 8.5 7.29995V12"
          stroke="#FFB600"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2.5"
        />
        <path
          d="M12 15.5V16.5"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect fill="white" height="19.5" transform="translate(5 2)" width="14" />
        </clipPath>
      </defs>
    </svg>
  );
}

LockIconSize24.defaultProps = defaultProps;

export default LockIconSize24;
